import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.21.11_@netlify+blobs@8.2.0_@oxc-project+types@0.143.0_@parcel+watcher@2.6.0_@types+nod_6ov5qllacxytyqciuuaqdxie5q/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  prefetchLinks: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}